import { createSlice } from "@reduxjs/toolkit"
import { userPasswordFormObject } from '@form/userPasswordFormFields'

const usersSlice = createSlice({
  name: 'users',
  initialState: {
    users: null,
    userFormObject: {},
    userPasswordFormObject: { ...userPasswordFormObject },
    errors: []
  },
  reducers: {
    fullUpdate: (state, action) => {
      return { ...state, ...action.payload }
    },
    updateUserFormObject: (state, action) => {
      state.userFormObject = action.payload
    },
    updateUserPasswordFormObject: (state, action) => {
      state.userPasswordFormObject = action.payload
    },
    initFormObjects: (state) => {
      return { ...state, userPasswordFormObject: { ...userPasswordFormObject }, userFormObject: {} }
    },
    updateUsers: (state, action) => {
      state.users = action.payload
    },
    updateErrors: (state, action) => {
      state.errors = action.payload
    }
  }
})

export const { fullUpdate, updateUserFormObject, updateUsers, updateUserPasswordFormObject, updateErrors, initFormObjects } = usersSlice.actions

export default usersSlice.reducer